import FirebaseDatabaseService from "../FirebaseDatabseService";

export default class FirestoreListObserver<T> {
  private _unsubscribe: () => void;
  private paths: string[];

  constructor(paths: string[]) {
    this.paths = paths;
  }

  public subscribe(onUpdate: (data: T[]) => void) {
    this.unsubscribe();
    this._unsubscribe = FirebaseDatabaseService.getListUpdates({
      paths: this.paths,
      onUpdate,
      onError: this.onError
    });
  }

  public unsubscribe() {
    if (this._unsubscribe) {
      this._unsubscribe();
    }
  }

  private onError = (error: Error) => {
    console.error(`Failed observing list ${this.paths.join("/")} ${error}`);
  };
}



// WEBPACK FOOTER //
// ./src/services/firebase/database/observers/FirestoreListObserver.ts